<template>
    <Multiselect
        v-model="selectedCountry"
        class="form-control-lg country-select"
        :placeholder="$t('common.form.country')"
        :id="$attrs.id"
        :options="countries"
        :searchable="true"
        :canDeselect="false"
        @search-change="autocomplete"
        ref="countrySelect"
        @change="countrySelected"
    />
</template>

<script>
import {nextTick} from 'vue';

import Multiselect from '@vueform/multiselect';

import {getCountries} from "@/api";

export default {
    name: 'CountrySelect',
    components: {
        Multiselect
    },
    props: ['modelValue', 'autocompleteAttribute'],
    emits: ['update:modelValue'],
    methods: {
        autocomplete: function(query) {
            if (query) {
                let matchingCountry = this.countries.find(country => country.value === query.toUpperCase() || country.label.toUpperCase() === query.toUpperCase())
                if (matchingCountry !== undefined) {
                    this.$refs.countrySelect.select(matchingCountry.value, matchingCountry.label);
                } else {
                    this.$refs.countrySelect.clear();
                }
            }
        },
        countrySelected: function(value) {
            this.$emit('update:modelValue', value);
        },
        updateAutocompleteAttribute() {
            //Hack to get the appropriate autocomplete attribute on the multiselect search.
            if (this.$attrs.id && this.autocompleteAttribute) {
                document.querySelector(`#${this.$attrs.id} .multiselect-search`).setAttribute('autocomplete', this.autocompleteAttribute);
            }
        }
    },
    mounted() {
        getCountries()
            .then(response => {
                this.countries = [];
                Object.entries(response.data).forEach(([key, val]) => {
                    this.countries.push({ label: val, value: key });
                });
            })
            .finally(() => {
                this.$refs.countrySelect.select('US', 'United States');
            });

        this.updateAutocompleteAttribute();
    },
    watch: {
        autocompleteAttribute() {
            //Let the DOM settle out and then update the autocomplete attribute.
            nextTick(() => {
                this.updateAutocompleteAttribute();
            });
        }
    },
    data() {
        return {
            selectedCountry: null,
            //Default a couple of the key countries, just in case the API is unavailable, the form can still function.
            countries: [
                {
                    label: 'United States',
                    value: 'US',
                },
                {
                    label: 'Canada',
                    value: 'CA',
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.country-select {
    &.is-invalid {
        border-color: $danger;
    }
}
</style>